(() => {
  const root = document.querySelector(".hp-gallery");
  const allitem = root.querySelectorAll(".media-image");

  const clickDesc = () => {
    allitem.forEach((item) => {
      const content = item.querySelector(".content");
      const button = item.querySelector("[data-link-gallery]");

      content.addEventListener("click", () => {
        button.click();
      });
    });
  };

  const addDataDot = () => {
    allitem.forEach((item) => {
      const pgph = item.querySelector(".content p") || null;

      if (pgph) {
        pgph.setAttribute("data-dot", "4");
      }
    });
  };

  // callback is called on intersection change
  const onIntersection = (entries, opts) => {
    entries.forEach((entry) =>
      entry.target.classList.toggle("visible", entry.isIntersecting)
    );
  };

  const seeScroll = () => {
    let observer = new IntersectionObserver(onIntersection, {
      root: null, // default is the viewport
      threshold: 0.1, // percentage of target's visible area. Triggers "onIntersection"
    });

    observer.observe(root);
    // observer.unobserve(entry.target);
  };

  const init = () => {
    if (root) {
      clickDesc();
      addDataDot();
      seeScroll();
    }
  };

  init();
})();
